import { render } from "./DS100SetupMenu.vue?vue&type=template&id=45582945&scoped=true"
import script from "./DS100SetupMenu.vue?vue&type=script&lang=js"
export * from "./DS100SetupMenu.vue?vue&type=script&lang=js"

import "./DS100SetupMenu.vue?vue&type=style&index=0&id=45582945&scoped=true&lang=css"

import exportComponent from "C:\\Users\\timdi\\Desktop\\funkapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45582945"]])

export default __exports__